<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Bowel Movements today: </span>

      <span class="stat-stat">
        {{ existingEntry.data.bowelMovements / 10 }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">Bowel movement pain:</span>

      <span class="stat-stat">
        {{ existingEntry.data.bowelMovementPain / 10 }}
      </span>
    </div>

    <div class="stat" v-if="score">
      <span class="stat-label">Bowel movement quality:</span>

      <span class="stat-stat">
        {{ score }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">Bowel movement quality:</span>

      <span class="stat-stat">
        {{ existingEntry.data.painAfter }}
      </span>
    </div>
  </div>
</template>

<script>
import Bowel from "../../../mixins/modules/bowel.js";

export default {
  name: "Stats",
  props: ["existingEntry"],
  mixins: [Bowel],
};
</script>

<style></style>
